import { graphql } from '../gql'

export const GET_FOOTER_QUERY = graphql(`
  query GetFooter($code: String, $id: ID) {
    getFooter(code: $code, id: $id) {
      id
      code
      address
      navLinks {
        label
        active
        children {
          label
          active
          type
          openInNewTab
          url
          linkRef
        }
      }
      socialLinks {
        label
        image
        imageUrl
        url
        active
      }
    }
  }
`)
